import React from 'react';
import StaticPageHeader from '../components/common/StaticPageHeader';
import useMerchantSettings from '../hooks/useMerchantSettings';
import { errorView, loadingView } from '../utils/Utilities';
import { Helmet } from 'react-helmet-async';
import '../assets/css/allpages.css';

const Privacy = () => {
    const { merchantSettings, loading, error } = useMerchantSettings();
    const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    const storeName = merchantSettings?.legal_name || 'Online Store';

    return (
        <div className="static-page-wrapper">
            <Helmet>
                <title>{`Privacy Policy | ${storeName}`}</title>
                <meta name="description" content={`Read the privacy policy for ${storeName}. Learn how we collect, use, and protect your personal information.`} />
                {currentOrigin && <link rel="canonical" href={`${currentOrigin}/privacy`} />}
            </Helmet>
            <StaticPageHeader title="Privacy Policy" />
            {loading ? loadingView() : error ? errorView(error) : (
                <div className="container static-page-container">
                    <div className="static-page-content">
                        <div dangerouslySetInnerHTML={{ __html: merchantSettings.merchant_configuration?.privacy_policy }} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default Privacy;